APPS.persons.show = (function(){
    var show = function(id){
        $.when( Backbone.Radio.channel('entities').request('person',id) ).done(function(data){ 
            APP.getView().showChildView('mainRegion', new pageView({
                model:data
            }) )
            
            window.document.title = data.attributes.name;
            if(typeof ga != "undefined"){ 
	            ga('set','title',"Personality: "+data.attributes.name);
				ga('send','pageview');
			}
			if(typeof gtag != "undefined"){
				gtag('set', { 'page_title': "Personality: "+data.attributes.name });
				gtag('event', 'page_view');
			}
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "Personality: "+data.attributes.name, '0', false, true); }

        })
    }

    /* VIEWS */
    // THE PAGE
    var pageView = Marionette.View.extend({
         template:"#tmpl-persons-show"
        ,className:"page_person"
        ,templateContext:function(){
            var imgs = JSON.parse(this.model.attributes.images);
			imgs = _.find(imgs,function(i){ return i.profile === "show-banner"; })
            
            return {
                showcase:(imgs && imgs.image)?imgs.image:""
            }
        }
        ,events:{
            //'click .stationPlaylistHeader':'togglePlaylistSection'
        }
        ,onAttach:function(){
            var that = this;
            
            //get details for the programs they are associated with
        	try{
            	var showIds = JSON.parse(this.model.attributes.programIds);
            	
            	_.each(showIds,function(showId){

	            	$.when( Backbone.Radio.channel('entities').request('show',showId) ).done(function(data){ 
		            	if(!data.attributes.error){
							var imgs = JSON.parse(data.attributes.images);
							var img = "";
							img = _.find(imgs,function(i){ return i.profile === "show-banner"; }) //radio program
							if(!img){ img = _.find(imgs,function(i){ return i.profile === "show-poster2x3"; }) } //tv show
							data.attributes.showImage = (img && img.image)?img.image:"";
							
							that.$el.find("#person-programsContainer").append( _.template($("#tmpl-persons-program").html())(data.attributes) )
						}
            		});
            		
            	})

            		
        	}catch(e){} //we don't care to catch. If there are no programs or the JSON is broken, so be it. This is secondary content.
            
        }
    })
    
    

    return {
        show:show
    }
})();


